import { type PublicClip } from '@air/api';
import { type Board, type Clip, type PublicBoard } from '@air/api/types';
import { type Upload } from '@air/redux-uploader';

import { type GalleryItemType } from '~/components/Gallery/types';
import { type TableRowType } from '~/components/TableView/basicTypes';

export type BasicTableRowProps<T> = {
  data: T;
};

export type AirTableMetadata = {
  isSelectable: boolean;
  type: GalleryItemType.board | GalleryItemType.file | GalleryItemType.upload | GalleryItemType.asset;
  item: PublicBoard | Board | Clip | PublicClip | Upload;
};

export type AirTableRow = {
  getMetadata?: () => AirTableMetadata;
} & TableRowType;

export const getTableColumnWidth = (key: string) => {
  switch (key) {
    case 'title':
      return 400;
    case 'buttons':
      return 68;
    case 'dateCreated':
    case 'dateTaken':
      return 160;
    case 'dateModified':
      return 170;
    case 'dateUploaded':
      return 190;
    case 'uploadedBy':
      return 220;
    case 'ext':
      return 115;
    case 'resolution':
      return 125;
    case 'size':
      return 90;
    case 'tagCount':
      return 110;
    case 'openCommentCount':
      return 150;
    case 'boardCount':
      return 120;
    case 'customField':
      return 240;
    case 'type':
      return 90;
    default:
      return 160;
  }
};

export type ActiveTableColumn = {
  fieldName: string;
  isCustomField: boolean;
  customFieldId?: string;
};

export const getMinTableWidth = (activeTableColumns: ActiveTableColumn[]): number => {
  return activeTableColumns.reduce(
    (acc, key) => acc + getTableColumnWidth(key.isCustomField ? 'customField' : key.fieldName),
    0,
  );
};

export const rightAlignedTableCells = new Set(['tagCount', 'openCommentCount', 'boardCount']);

export type OnRenameFunction = () => void;
